/*
 * Woerdman: lichte, zelfstandige slider voor de homepage-hero banner
 * (sections/banners-with-categories.liquid). Bewust geen Swiper-afhankelijkheid:
 * simpele crossfade + automatisch doorschuiven + klikbare dots.
 */
(function () {
  'use strict';

  function BannerSlideshow(root) {
    this.root = root;
    this.slides = Array.prototype.slice.call(root.querySelectorAll('[data-banner-slideshow-slide]'));
    this.dots = Array.prototype.slice.call(root.querySelectorAll('[data-banner-slideshow-dot]'));
    this.delay = parseInt(root.getAttribute('data-autoplay-delay'), 10) || 8000;
    this.index = 0;
    this.timer = null;
    this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (this.slides.length < 2) return;

    var self = this;

    this.dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var targetIndex = parseInt(dot.getAttribute('data-index'), 10);
        self.goTo(targetIndex);
        self.restart();
      });
    });

    if (!this.prefersReducedMotion) {
      root.addEventListener('mouseenter', function () {
        self.stop();
      });
      root.addEventListener('mouseleave', function () {
        self.start();
      });
      root.addEventListener('focusin', function () {
        self.stop();
      });
      root.addEventListener('focusout', function () {
        self.start();
      });

      this.start();
    }

    this.touchStartX = 0;
    this.touchStartY = 0;
    this.touchDeltaX = 0;
    this.isSwiping = false;

    root.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      self.touchStartX = e.touches[0].clientX;
      self.touchStartY = e.touches[0].clientY;
      self.touchDeltaX = 0;
      self.isSwiping = false;
    }, { passive: true });

    root.addEventListener('touchmove', function (e) {
      if (e.touches.length !== 1) return;
      var dx = e.touches[0].clientX - self.touchStartX;
      var dy = e.touches[0].clientY - self.touchStartY;
      if (!self.isSwiping && Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 10) {
        self.isSwiping = true;
      }
      if (self.isSwiping) {
        self.touchDeltaX = dx;
        e.preventDefault();
      }
    }, { passive: false });

    root.addEventListener('touchend', function () {
      if (self.isSwiping && Math.abs(self.touchDeltaX) > 40) {
        if (self.touchDeltaX < 0) {
          self.next();
        } else {
          self.prev();
        }
        self.restart();
      }
      self.isSwiping = false;
      self.touchDeltaX = 0;
    });
  }

  BannerSlideshow.prototype.goTo = function (nextIndex) {
    if (nextIndex === this.index || !this.slides[nextIndex]) return;

    var current = this.slides[this.index];
    current.classList.remove('is-active');
    current.setAttribute('aria-hidden', 'true');
    if (this.dots[this.index]) this.dots[this.index].classList.remove('is-active');

    this.index = nextIndex;

    var next = this.slides[this.index];
    next.classList.add('is-active');
    next.setAttribute('aria-hidden', 'false');
    if (this.dots[this.index]) this.dots[this.index].classList.add('is-active');
  };

  BannerSlideshow.prototype.next = function () {
    this.goTo((this.index + 1) % this.slides.length);
  };

  BannerSlideshow.prototype.prev = function () {
    this.goTo((this.index - 1 + this.slides.length) % this.slides.length);
  };

  BannerSlideshow.prototype.start = function () {
    this.stop();
    var self = this;
    this.timer = window.setInterval(function () {
      self.next();
    }, this.delay);
  };

  BannerSlideshow.prototype.stop = function () {
    if (this.timer) {
      window.clearInterval(this.timer);
      this.timer = null;
    }
  };

  BannerSlideshow.prototype.restart = function () {
    if (!this.prefersReducedMotion) this.start();
  };

  function init() {
    document.querySelectorAll('[data-banner-slideshow]').forEach(function (root) {
      if (root.bannerSlideshowInitialized) return;
      root.bannerSlideshowInitialized = true;
      new BannerSlideshow(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
